import React from 'react';
import { CONTACTS, formatTime } from './chatData';

function ChatSidebar({ contacts, conversations, activeChat, onSelect, onDelete, isOpen, searchQuery, onSearchChange }) {
  const getLastMessage = (contactId) => {
    const conv = conversations[contactId];
    if (!conv || conv.messages.length === 0) return null;
    return conv.messages[conv.messages.length - 1];
  };

  const getSenderName = (senderId) => {
    if (senderId === 'user1') return 'You';
    const contact = CONTACTS.find((c) => c.id === senderId);
    return contact ? contact.name.split(' ')[0] : '';
  };

  const sortedContacts = [...contacts].sort((a, b) => {
    const lastA = getLastMessage(a.id);
    const lastB = getLastMessage(b.id);
    if (!lastA && !lastB) return 0;
    if (!lastA) return 1;
    if (!lastB) return -1;
    return lastB.timestamp - lastA.timestamp;
  });

  const filtered = sortedContacts.filter((c) =>
    c.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className={`chat-sidebar ${isOpen ? 'open' : ''}`}>
      <div className="chat-sidebar-search">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
        </svg>
        <input
          type="text"
          placeholder="Search conversations..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      <div className="chat-sidebar-list">
        {filtered.map((contact) => {
          const lastMsg = getLastMessage(contact.id);
          const conv = conversations[contact.id];
          const unread = conv?.unread || 0;
          const isTyping = conv?.typing || false;

          return (
            <div
              key={contact.id}
              className={`chat-sidebar-item ${activeChat === contact.id ? 'active' : ''} ${unread > 0 ? 'has-unread' : ''}`}
              onClick={() => onSelect(contact.id)}
              onContextMenu={(e) => {
                e.preventDefault();
                if (window.confirm(`Clear conversation with ${contact.name}?`)) {
                  onDelete(contact.id);
                }
              }}
            >
              <div className="chat-sidebar-avatar">
                <span className="chat-avatar-emoji">{contact.avatar}</span>
                <span className={`chat-status-dot ${contact.status}`}></span>
              </div>
              <div className="chat-sidebar-info">
                <div className="chat-sidebar-top">
                  <span className="chat-sidebar-name">{contact.name}</span>
                  {lastMsg && (
                    <span className="chat-sidebar-time">{formatTime(lastMsg.timestamp)}</span>
                  )}
                </div>
                <div className="chat-sidebar-bottom">
                  <span className="chat-sidebar-preview">
                    {isTyping ? (
                      <span className="chat-typing-text">typing...</span>
                    ) : lastMsg ? (
                      <>
                        {contact.isGroup && lastMsg.senderId !== 'user1' && (
                          <span className="chat-preview-sender">{getSenderName(lastMsg.senderId)}: </span>
                        )}
                        {lastMsg.senderId === 'user1' && (
                          <span className="chat-preview-sender">You: </span>
                        )}
                        {lastMsg.text.length > 40 ? lastMsg.text.slice(0, 40) + '...' : lastMsg.text}
                      </>
                    ) : (
                      <span className="chat-no-messages">No messages yet</span>
                    )}
                  </span>
                  {unread > 0 && <span className="chat-unread-badge">{unread}</span>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ChatSidebar;
